import { createCachedRequest } from '../lib/apiCache';
import { getListAppointment as fetchListAppointment, getFormFields as fetchFormFields } from './appointmentService';

export const getListAppointmentCached = createCachedRequest(
    ({ transactionId, locationId, gateDirection }) => fetchListAppointment({ transactionId, locationId, gateDirection }),
    {
        key: 'appointments_list',
        ttl: 0,
        debounceMs: 500,
        maxEntries: 100,
    }
);

export const getFormFieldsCached = createCachedRequest(({ gateId, locationId, companyId }) => fetchFormFields({ gateId, locationId, companyId }), {
    key: 'form_fields',
    ttl: 0,
    debounceMs: 500,
    maxEntries: 50,
});

export const clearAppointmentCache = () => {
    getListAppointmentCached.clearCache();
    getFormFieldsCached.clearCache();
};

export const invalidateAppointmentCache = () => {
    getListAppointmentCached.invalidate();
    getFormFieldsCached.invalidate();
};
